import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({
    children,
    delay = 0,
    y = 32,
    className = "",
    once = true,
}) => {
    const reduce = useReducedMotion();
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y: reduce ? 0 : y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, margin: "-70px" }}
            transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.div>
    );
};
